import React from "react"
import { AuthCard, AuthLayout } from "./login/Shared"
import { H1 } from "@carrotfertility/carotene"
import { Spacer } from "./atoms/Atoms"
import { Body } from "./atoms/Bodies"
import { TextLink } from "./atoms/links/TextLink"
import L10n from "../../lib/carrot-l10n"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()
const headerText = l`Something’s not working`

function Error(): JSX.Element {
  return (
    <AuthLayout title={headerText}>
      <AuthCard>
        <Spacer height={4} />
        <div className="flex flex-row justify-center">
          <H1>{headerText}</H1>
        </div>
        <Spacer height={0.5} />
        <Body color="black-80" align="tc">
          {l`Try reloading this page. If the problem persists, feel free to `}
          <TextLink to="mailto:support@get-carrot.com">{l`contact us`}</TextLink>
          {l`.`}
        </Body>
        <Spacer height={3} />
      </AuthCard>
    </AuthLayout>
  )
}

export { Error }
